import { Delete, Edit } from "@mui/icons-material";
import { Button, TextField } from "@mui/material";

import { Link } from "react-router-dom";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import * as XLSX from "xlsx"; // Importing xlsx library
import axios from "axios";
import { getToken, base_url } from "../../config/config";

const ProjectReports = () => {
  const [apiData, setApiData] = useState([]);
  const [refreshId, setRefreshId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const handleEdit = (id) => {
    console.log("edited");
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${base_url}/v1/deleteProject`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      });
      const data = await response.json();
      console.log(data);
      if (data.success) {
        setApiData((prevData) =>
          prevData.filter((project) => project._id !== id),
        );
        setRefreshId(Date.now().toString()); // Update refreshId to trigger useEffect hook
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    console.log("Refreshing table...");
    axios
      .get(`${base_url}/v1/getAllProjectReport`)
      .then((response) => {
        if (response.data.status === 1) {
          setApiData(response.data.data);
        } else {
          console.error("Error fetching API data:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching API data:", error);
      });
  }, [refreshId]);

  useEffect(() => {
    const filtered = apiData.filter((project) => {
      const projectDate = new Date(project.date);
      const start = new Date(startDate);
      const end = new Date(endDate);
      return (
        (!startDate || projectDate >= start) && (!endDate || projectDate <= end)
      );
    });
    setFilteredData(filtered);
  }, [startDate, endDate, apiData]);

  const columns = useMemo(
    () => [
      {
        id: "project",
        header: "Project",
        columns: [
          {
            accessorKey: "ANR",
            header: "ANR",
            size: 150,
            Cell: ({ row }) => (
              <Link to={`/ProjectSummary/${row.original.ANR}`}>
                {row.original.ANR}
              </Link>
            ),
          },
          {
            accessorKey: "Menge",
            header: "Menge",
            size: 50,
          },
          {
            accessorKey: "Auftragsbezeichnung",
            header: "Auftragsbezeichnung",
            size: 150,
          },
          {
            accessorKey: "Artikelnummer",
            header: "Artikelnummer",
            size: 100,
          },
          {
            accessorKey: "status",
            header: "Status",
            size: 100,
          },
          {
            accessorKey: "Erläuterung",
            header: "Erläuterung",
            size: 150,
          },
        ],
      },
    ],
    [],
  );

  const handleExport = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
    XLSX.writeFile(workbook, "projects.xlsx");
  };

  const table = useMaterialReactTable({
    columns,
    data: filteredData,
    initialState: { density: "compact" },
    enableColumnResizing: true,
  });

  return (
    <div style={{ margin: "20px" }}>
      <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
        <TextField
          label='Start Date'
          type='date'
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          label='End Date'
          type='date'
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </div>
      <Button
        variant='contained'
        color='primary'
        onClick={handleExport}
        style={{ marginBottom: "20px" }}>
        Export to Excel
      </Button>
      <div
        id='table-container'
        style={{ overflow: "hidden", marginBottom: "20px" }}>
        <MaterialReactTable
          table={{
            ...table,
            columns: columns,
            data: filteredData,
          }}
        />
      </div>
    </div>
  );
};

export default ProjectReports;
